/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuMultiSelectSearch_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterStone_viewer$ref: FragmentReference;
export type SbSharedRefineMenuFilterStone_viewer = {|
  +$fragmentRefs: SbSharedRefineMenuMultiSelectSearch_viewer$ref,
  +$refType: SbSharedRefineMenuFilterStone_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterStone_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6baebc0795a4435bd2d9eea93a8897e0';
module.exports = node;
